import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	recentlyViewedPlans: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	recentlyViewedPlans: {
		id: 'command-palette-quick-search.use-quick-search-command.use-quick-search-children.recent.plans.recently-viewed-plans',
		defaultMessage: 'Recently Viewed Plans',
		description: 'Section title for recently viewed plans',
	},
});
